export default __webpack_public_path__ + "static/breakupDejected-d33cdeba278af717162be81a6681ba44.svg";